// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_file__owq4N {
  width: 48%;
  margin: 0 1%;
  height: auto;
  /* aspect-ratio: 1; */
  /* height: 106px; */
  display: flex;
  /* margin-bottom:10px; */
  border-radius: 5px;


  background: transparent !important;
}

.styles_fixedHeight__aFpm8 {
  height: 106px;
  margin-bottom: 10px !important;
}

.styles_fixedHeightSmall__SCRiI {
  margin-bottom: 10px !important;
}

.styles_imageRadius__KKLcV {
  border-radius: 10px !important;
}

.styles_imageRadius__KKLcV>div {
  border-radius: 10px !important;
}

.styles_boxBorder__7pVBI {
  border: 0.5px solid rgba(0, 0, 0, 0.50);
}

/* .extraFileStyle{
    height:106px;
  } */
.styles_file__owq4N>div {
  background-color: transparent;
}

.styles_file__owq4N img {
  min-width: 100% !important;
  max-height: 300px !important;
  object-fit: cover;
}

.styles_fileSmall__ViF5F {
  width: 18%;
  margin: 0 1%;
  aspect-ratio: 1;

  /* height: 150px; */
  display: flex;
  /* margin-bottom:10px; */
  border-radius: 5px;
  max-height: 300px;
  /* border: 1px solid rgba(0, 0, 0, 0.50); */

}

.styles_extraMargin__TRAZ- {
  margin-bottom: 50px !important;
}

.styles_imageBack__JAap\\+ {
  background-color: #ccc !important;
}

.styles_imageNoBack__4Py71 {
  /* background-color: unset !important; */
  /* background-color: rgba(0, 0, 0, 0.3) !important; */
  background-color: #ccc !important;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  /* justify-content: flex-start; */
}

.styles_imageNoBack__4Py71 img {}

.styles_fileContainer__VSQXl {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.3);

}

.styles_extraNameStyle__Iuemw {
  max-width: 86%;
  position: absolute;
  bottom: -40px;
  right: 10px;
  /* cursor:pointer; */
  padding: 4px;
  font-size: 12px;
  /* background: rgba(0,0,0,0.6); */
  border-radius: 4px;
  /* color: #fff; */
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -moz-text-size-adjust: auto;
  /* color: #000; */

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.styles_extraNameStyleMusic__YeiWD {
  max-width: 86%;
  position: absolute;
  top: 10px;
  left: 40px;
  /* cursor:pointer; */
  padding: 4px;
  font-size: 12px;
  /* background: rgba(0,0,0,0.6); */
  border-radius: 4px;
  /* color: #fff; */
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -moz-text-size-adjust: auto;
  /* color: #000; */
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.styles_extraNameStyleFile__1YA6X {
  max-width: 86%;
  position: absolute;
  bottom: -40px;
  right: 10px;
  /* cursor:pointer; */
  padding: 4px;
  font-size: 12px;
  /* background: rgba(0,0,0,0.6); */
  border-radius: 4px;
  /* color: #fff; */
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -moz-text-size-adjust: auto;
  /* color: #000; */

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.styles_extraPlayerStyle__H9C1R {
  align-self: flex-end;
  margin-bottom: 20px;
}

.styles_file__owq4N img,
.styles_file__owq4N video {
  width: auto;
  max-width: 100%;
  max-height: 100%;

}

.styles_fileSmall__ViF5F img,
.styles_fileSmall__ViF5F video {
  width: auto;
  max-width: 100%;
  max-height: 100%;
  /* margin:0 auto; */

}

.styles_loader__1AMwf {
  height: 100%;
  width: 100%;
}

.styles_loader__1AMwf span {
  width: 50px;
  height: 50px;
  margin: 50px;
}

.styles_absoluteName__nHUZK {
  max-width: 86%;
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  padding: 4px;
  font-size: 12px;

  border-radius: 4px;
  /* color: #fff; */
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -moz-text-size-adjust: auto;

  /* color: #000; */

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

@media only screen and (max-width: 1000px) {
  .styles_fixedHeightSmall__SCRiI {
    height: 150px;
  }

  .styles_fileSmall__ViF5F {
    width: 31%;
    margin: 0 1%;
    /* height: 150px; */
    display: flex;
    /* margin-bottom:10px; */

  }
}

@media only screen and (max-width: 800px) {

  .styles_file__owq4N {
    width: 98%;
    margin: 0 1%;
    display: flex;
    /* margin-bottom:10px; */

  }

  .styles_fileSmall__ViF5F {
    width: 48%;
    margin: 0 1%;
    /* height: 150px; */
    display: flex;
    /* margin-bottom:10px; */

  }
}

@media only screen and (max-width: 650px) {


  .styles_fileSmall__ViF5F {
    width: 98%;
    margin: 0 1%;
    /* height: 150px; */
    display: flex;
    /* margin-bottom:10px; */

  }
}



@media only screen and (max-width: 450px) {
  .styles_fixedHeight__aFpm8 {
    height: 150px;
  }

  .styles_file__owq4N {
    width: 98%;
    margin: 0 1%;
    /* height: 150px; */
    display: flex;
    /* margin-bottom:10px; */

  }

  .styles_fileSmall__ViF5F {
    width: 98%;
    margin: 0 1%;
    /* height: 150px; */
    display: flex;
    /* margin-bottom:10px; */

  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/FileTypesContainer/styles.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,wBAAwB;EACxB,kBAAkB;;;EAGlB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;KAEK;AACL;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,eAAe;;EAEf,mBAAmB;EACnB,aAAa;EACb,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,2CAA2C;;AAE7C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,wCAAwC;EACxC,qDAAqD;EACrD,iCAAiC;EACjC,4BAA4B;EAC5B,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA,gCAAkB;;AAElB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;;AAEtC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;EAC5B,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;EAC3B,iBAAiB;;EAEjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;EAC5B,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;EAC3B,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;EAC5B,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;EAC3B,iBAAiB;;EAEjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,gBAAgB;;AAElB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;;AAErB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,eAAe;;EAEf,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;EAC5B,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;;EAE3B,iBAAiB;;EAEjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,wBAAwB;;EAE1B;AACF;;AAEA;;EAEE;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,wBAAwB;;EAE1B;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,wBAAwB;;EAE1B;AACF;;AAEA;;;EAGE;IACE,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,wBAAwB;;EAE1B;AACF;;;;AAIA;EACE;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,wBAAwB;;EAE1B;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,wBAAwB;;EAE1B;AACF","sourcesContent":[".file {\n  width: 48%;\n  margin: 0 1%;\n  height: auto;\n  /* aspect-ratio: 1; */\n  /* height: 106px; */\n  display: flex;\n  /* margin-bottom:10px; */\n  border-radius: 5px;\n\n\n  background: transparent !important;\n}\n\n.fixedHeight {\n  height: 106px;\n  margin-bottom: 10px !important;\n}\n\n.fixedHeightSmall {\n  margin-bottom: 10px !important;\n}\n\n.imageRadius {\n  border-radius: 10px !important;\n}\n\n.imageRadius>div {\n  border-radius: 10px !important;\n}\n\n.boxBorder {\n  border: 0.5px solid rgba(0, 0, 0, 0.50);\n}\n\n/* .extraFileStyle{\n    height:106px;\n  } */\n.file>div {\n  background-color: transparent;\n}\n\n.file img {\n  min-width: 100% !important;\n  max-height: 300px !important;\n  object-fit: cover;\n}\n\n.fileSmall {\n  width: 18%;\n  margin: 0 1%;\n  aspect-ratio: 1;\n\n  /* height: 150px; */\n  display: flex;\n  /* margin-bottom:10px; */\n  border-radius: 5px;\n  max-height: 300px;\n  /* border: 1px solid rgba(0, 0, 0, 0.50); */\n\n}\n\n.extraMargin {\n  margin-bottom: 50px !important;\n}\n\n.imageBack {\n  background-color: #ccc !important;\n}\n\n.imageNoBack {\n  /* background-color: unset !important; */\n  /* background-color: rgba(0, 0, 0, 0.3) !important; */\n  background-color: #ccc !important;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  /* justify-content: flex-start; */\n}\n\n.imageNoBack img {}\n\n.fileContainer {\n  width: 100%;\n  height: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.3);\n\n}\n\n.extraNameStyle {\n  max-width: 86%;\n  position: absolute;\n  bottom: -40px;\n  right: 10px;\n  /* cursor:pointer; */\n  padding: 4px;\n  font-size: 12px;\n  /* background: rgba(0,0,0,0.6); */\n  border-radius: 4px;\n  /* color: #fff; */\n  word-break: break-all;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -moz-text-size-adjust: auto;\n  /* color: #000; */\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.extraNameStyleMusic {\n  max-width: 86%;\n  position: absolute;\n  top: 10px;\n  left: 40px;\n  /* cursor:pointer; */\n  padding: 4px;\n  font-size: 12px;\n  /* background: rgba(0,0,0,0.6); */\n  border-radius: 4px;\n  /* color: #fff; */\n  word-break: break-all;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -moz-text-size-adjust: auto;\n  /* color: #000; */\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.extraNameStyleFile {\n  max-width: 86%;\n  position: absolute;\n  bottom: -40px;\n  right: 10px;\n  /* cursor:pointer; */\n  padding: 4px;\n  font-size: 12px;\n  /* background: rgba(0,0,0,0.6); */\n  border-radius: 4px;\n  /* color: #fff; */\n  word-break: break-all;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -moz-text-size-adjust: auto;\n  /* color: #000; */\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.extraPlayerStyle {\n  align-self: flex-end;\n  margin-bottom: 20px;\n}\n\n.file img,\n.file video {\n  width: auto;\n  max-width: 100%;\n  max-height: 100%;\n\n}\n\n.fileSmall img,\n.fileSmall video {\n  width: auto;\n  max-width: 100%;\n  max-height: 100%;\n  /* margin:0 auto; */\n\n}\n\n.loader {\n  height: 100%;\n  width: 100%;\n}\n\n.loader span {\n  width: 50px;\n  height: 50px;\n  margin: 50px;\n}\n\n.absoluteName {\n  max-width: 86%;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  cursor: pointer;\n  padding: 4px;\n  font-size: 12px;\n\n  border-radius: 4px;\n  /* color: #fff; */\n  word-break: break-all;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -moz-text-size-adjust: auto;\n\n  /* color: #000; */\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n@media only screen and (max-width: 1000px) {\n  .fixedHeightSmall {\n    height: 150px;\n  }\n\n  .fileSmall {\n    width: 31%;\n    margin: 0 1%;\n    /* height: 150px; */\n    display: flex;\n    /* margin-bottom:10px; */\n\n  }\n}\n\n@media only screen and (max-width: 800px) {\n\n  .file {\n    width: 98%;\n    margin: 0 1%;\n    display: flex;\n    /* margin-bottom:10px; */\n\n  }\n\n  .fileSmall {\n    width: 48%;\n    margin: 0 1%;\n    /* height: 150px; */\n    display: flex;\n    /* margin-bottom:10px; */\n\n  }\n}\n\n@media only screen and (max-width: 650px) {\n\n\n  .fileSmall {\n    width: 98%;\n    margin: 0 1%;\n    /* height: 150px; */\n    display: flex;\n    /* margin-bottom:10px; */\n\n  }\n}\n\n\n\n@media only screen and (max-width: 450px) {\n  .fixedHeight {\n    height: 150px;\n  }\n\n  .file {\n    width: 98%;\n    margin: 0 1%;\n    /* height: 150px; */\n    display: flex;\n    /* margin-bottom:10px; */\n\n  }\n\n  .fileSmall {\n    width: 98%;\n    margin: 0 1%;\n    /* height: 150px; */\n    display: flex;\n    /* margin-bottom:10px; */\n\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"file": `styles_file__owq4N`,
	"fixedHeight": `styles_fixedHeight__aFpm8`,
	"fixedHeightSmall": `styles_fixedHeightSmall__SCRiI`,
	"imageRadius": `styles_imageRadius__KKLcV`,
	"boxBorder": `styles_boxBorder__7pVBI`,
	"fileSmall": `styles_fileSmall__ViF5F`,
	"extraMargin": `styles_extraMargin__TRAZ-`,
	"imageBack": `styles_imageBack__JAap+`,
	"imageNoBack": `styles_imageNoBack__4Py71`,
	"fileContainer": `styles_fileContainer__VSQXl`,
	"extraNameStyle": `styles_extraNameStyle__Iuemw`,
	"extraNameStyleMusic": `styles_extraNameStyleMusic__YeiWD`,
	"extraNameStyleFile": `styles_extraNameStyleFile__1YA6X`,
	"extraPlayerStyle": `styles_extraPlayerStyle__H9C1R`,
	"loader": `styles_loader__1AMwf`,
	"absoluteName": `styles_absoluteName__nHUZK`
};
export default ___CSS_LOADER_EXPORT___;
